var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditSquare = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2524 2.74992L13.5678 5.04142L14.3442 4.26395C14.5531 4.0548 14.6529 3.80255 14.6439 3.5072C14.6348 3.21149 14.5258 2.95906 14.317 2.74992L13.5542 1.98608C13.3454 1.77694 13.0889 1.67236 12.7849 1.67236C12.4806 1.67236 12.224 1.77694 12.0151 1.98608L11.2524 2.74992ZM7.63213 11.0001L12.8526 5.77113L10.5371 3.45235L5.31665 8.68135V10.6909C5.31665 10.8353 5.45396 11.0001 5.63702 11.0001H7.63213ZM1.72422 14.6261C1.98555 14.8874 2.29955 15.0181 2.66622 15.0181H11.9996C12.3662 15.0181 12.6802 14.8874 12.9416 14.6261C13.2024 14.3652 13.3329 14.0514 13.3329 13.6847V7.18019L11.9996 8.51353V13.6847H2.66622V4.3514H7.73823L9.07156 3.01807H2.66622C2.29955 3.01807 1.98555 3.14851 1.72422 3.4094C1.46333 3.67073 1.33289 3.98473 1.33289 4.3514V13.6847C1.33289 14.0514 1.46333 14.3652 1.72422 14.6261Z",
    fill: "#767676"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-square.ccea895b.svg";
export { ForwardRef as ReactComponent };